export default "__VITE_ASSET__CAP52tJD__"